document.addEventListener('shopify:section:load', sm2_load_all);
document.addEventListener('shopify:section:unload', sm2_unload_all);
window.addEventListener("load", sm2_load_all);


function sm2_load_all(event) {
  loadCollectionSliders();
}

function sm2_unload_all(event) {

}

function loadCollectionSliders() {
 jQuery('.collection-slider .collection-slider__slideshow').addClass('owl-carousel owl-theme').owlCarousel({
   center: true,
      loop: true,
      margin: 0,
      nav: true,
      dots: false,
      navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
      responsive:{
          0:{
              items:2
          },
          600:{
              items:3
          },
          1000:{
              items:4
          },
          1400:{
              items:5
          },
          2000:{
              items:6
          }
      }
  }); 
}

jQuery(function() {
    jQuery('.beefup').beefup({
        openClass: 'is-open'
    });
});


// Product Gallery
class Slider {
  constructor( selector, secondarySelector ) {
    this.slider = tns({
      container: selector,
      items: 1,
      autoHeight: true,
      prevButton: '.primary-gallery-prev',
      nextButton: '.primary-gallery-next',
      slideBy: 'page',
      loop: true,
      navContainer: secondarySelector
    });

    this.thumbnails = tns({
      container: secondarySelector,
      items: 3,
      axis: "vertical",
      prevButton: '.secondary-gallery-prev',
      nextButton: '.secondary-gallery-next',
      loop: false,
      slideBy: 1,
      nav: false
    });

    this.slider.events.on( 'indexChanged', evt => this.nextSlide( evt ));
  }

  nextSlide( evt ) {
    // hack beacause of strange idexes from tns slider
    const indexToGoTo = evt.index > this.slider.getInfo().slideCount ? 0 : evt.index - 1;

    this.thumbnails.goTo( indexToGoTo );
  }

}

function load_custom_tag_filters() {
    jQuery('.collection-custom-filter-tag-checkbox, .price-custom-filter-tag-checkbox').on('change', function () {
        var filter = Array.prototype.map.call(
            document.querySelectorAll('input.collection-custom-filter-tag-checkbox:checked, input.price-custom-filter-tag-checkbox:checked'),
            function (el) { return el.value; }
        ).join('+');
        var link = jQuery('#link-to-tag-generic a').attr('href').replace(/\+/g, '%20');
        window.location.href = link.replace(/(\/|=)tag($|\?|&)/, '$1' + filter + '$2');
    });
}

jQuery(function() {
  if (jQuery('#productGalleryPrimarySlider').length > 0 && jQuery('#productGallerySecondarySlider').length > 0)
  	var slider = new Slider('#productGalleryPrimarySlider', '#productGallerySecondarySlider');
  load_custom_tag_filters();
});